import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ReactQuill from "react-quill";

import Utils from '../../Utils';

import * as experimentsActions from '../../actions/actionsExperiments';

const oneHot = ["", " ", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "!", "\"", "#", "$", "%", "&", "'", "(", ")", "*", "+", ",", "-", ".", "/", ":", ";", "<", "=", ">", "?", "@", "[", "\\", "]", "^", "_", "`", "{", "¦", "}", "~", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

class TextDelta extends Component {
  constructor (props) {
    super(props);

    this.refReactQuill = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidUpdate (prevProps) {
    if (prevProps.experiments.doOutputDeltas) {
      this.props.actions.setDoOutputDeltas(false);
    }
  }

  handleKeyDown (e) {
    switch (e.key.toUpperCase()) {
      case "END":
        this.props.actions.setDoOutputDeltas(true);
        break;
        
      case "ESCAPE":
        this.refReactQuill.current.setEditorContents(this.refReactQuill.current.editor, "");
        this.props.actions.clearDeltaArray();
        break;

      default:
        break;
    }
  }

  handleChange (content, delta, source, editor) {
    let r = 0, d = 0, i = "";

    delta.ops.forEach((operation) => {
      r = operation.retain !== undefined ? operation.retain : r;
      d = operation.delete !== undefined ? operation.delete : d;
      i = operation.insert !== undefined ? operation.insert : i;
    });

    this.props.actions.addDelta([r, d, oneHot.indexOf(i)]);
  }

  render() {
    const { deltaArray, doOutputDeltas } = this.props.experiments;

    return (
      <div className='inner-container'>
        <div>
          <ReactQuill onChange={this.handleChange} onKeyDown={this.handleKeyDown} ref={this.refReactQuill} />
        </div>

        <div className="delta-history">
          <h3>Delta History</h3>
          <div className="values">
            <div>
              <textarea value={deltaArray.map((delta, i) => (`${delta[0]}.${delta[1]}.${delta[2]}`))} readOnly={true} />
            </div>
            {doOutputDeltas && (
            <div>
              {deltaArray.map((delta, i) => 
                <div className="value" key={i}>
                  {Utils.padElement(<span>&nbsp;</span>, <span key={0}>{delta[0]}</span>, 5)},
                  {Utils.padElement(<span>&nbsp;</span>, <span key={0}>{delta[1]}</span>, 5)},
                  {Utils.padElement(<span>&nbsp;</span>, <span key={0}>{oneHot[delta[2]]}</span>, 5)}
                </div>)}
            </div>)}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    experiments: state.experiments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(experimentsActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextDelta);



// WEBPACK FOOTER //
// ./src/components/experiments/TextDelta.js